import AContainer from '../../library/ExtendedObjects/AContainer.js';
import WordBlock from './WordBlock.js';
import gameData from '../../gameData.js';

export default class PortalDuo extends AContainer
{
    constructor(scene)
    {
        super(scene);
        this.createPortal();

        this.name = "PortalDuo";

        this.words = [];
        this.scene.shuffleArray(gameData.duoBlockConfig);

        this.createNewWords();
    }

    createPortal()
    {
        this.portal = this.create(0, 0, "WordPortalBlue");

        this.verbsPast = gameData.pastVerbs.slice();
        this.verbsPresent = gameData.presentVerbs.slice();
        this.scene.shuffleArray(this.verbsPast);
        this.scene.shuffleArray(this.verbsPresent);
    }

    rotatePortal()
    {
        let randAngle = Phaser.Math.Between(0, 360);
        let randTime = Phaser.Math.Between(10000, 20000);

        this.scene.addTween(this.portal, randTime, {angle:randAngle}, Phaser.Math.Easing.Quadratic.InOut,
            ()=>{this.rotatePortal();});
    }

    tweenInPortal()
    {
        this.scene.addTween(this, 2000, {y:730}, Phaser.Math.Easing.Quadratic.Out,
            ()=>{this.activatePortals();});
    }

    tweenOutPortal()
    {
        this.scene.addTween(this, 1000, {y:1050}, Phaser.Math.Easing.Quadratic.In);
    }

    activatePortals()
    {
        for(let n = 0; n < this.words.length; n++){
            let newDelay = 100*n;
            this.words[n].tweenInBlock(newDelay);
        }

        this.scene.addDelay(1500, ()=>{if(!gameData.gamePaused) this.enableWords();});
    }

    createNewWords()
    {
        gameData.duoBlockConfig[0].type = "past";
        gameData.duoBlockConfig[0].word = gameData.sentences[0].past;
        gameData.duoBlockConfig[0].ind = 0;
        gameData.duoBlockConfig[1].type = "present";
        gameData.duoBlockConfig[1].word = gameData.sentences[0].present;
        gameData.duoBlockConfig[1].ind = 1;

        let block1 = this.scene.addContainer(this.scene.mid.x + 100 + gameData.duoBlockConfig[0].x, 730 + gameData.duoBlockConfig[0].y, new WordBlock(this.scene, this, gameData.duoBlockConfig[0]));
        let block2 = this.scene.addContainer(this.scene.mid.x + 100 + gameData.duoBlockConfig[1].x, 730 + gameData.duoBlockConfig[1].y, new WordBlock(this.scene, this, gameData.duoBlockConfig[1]));
        block1.setDepth(2);
        block2.setDepth(2);
        this.words.push(block1);
        this.words.push(block2);

        if(gameData.score > 0){
            block1.tweenInBlock(100);
            block2.tweenInBlock(100);
        }

        //move the first element from word arrays to back.
        let pastS = this.verbsPast.splice(0, 1);
        this.verbsPast.push(pastS[0]);
        let presentS = this.verbsPresent.splice(0, 1);
        this.verbsPresent.push(presentS[0]);

        for(let w = 0; w >this.words.length; w++){
            this.words[w].config.ind = b;
        }

        this.scene.addDelay(1000, ()=>{if(!gameData.gamePaused) this.enableWords();});
    }

    clearWord()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].resetWord("blue");
        }

        this.words = [];

        gameData.sentences.push(gameData.sentences.shift());

        this.scene.addDelay(550, ()=>{this.createNewWords();});
    }

    clearPortal()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].clearWord();
        }

        this.words = [];
        
        this.scene.addDelay(1000, ()=>{this.scene.tweenOutPortals();});
    }

    enableWords()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].setInteractive();
            this.scene.input.setDraggable(this.words[n]);
        }
    }

    disableWords()
    {
        for(let n = 0; n < this.words.length; n++){
            this.words[n].disableInteractive();
        }
    }

    cleanUp()
    {
        this.scene.killTween(this.portal);
        this.portal.destroy();

        this.disableWords();

        for(let n = 0; n < this.words.length; n++){
            this.words[n].cleanUp();
        }

        this.verbsPast = [];
        this.verbsPresent = [];
    }
}